/**
 * CompetitorCard - Displays competitor information with relationship type
 * Pure presentational component wrapped with React.memo
 */

import { memo } from 'react';
import type { CompetitorReference } from '../../../types';
import { relationshipColors, relationshipBadgeColors } from './constants';

interface CompetitorCardProps {
  competitor: CompetitorReference;
}

function CompetitorCardComponent({ competitor }: CompetitorCardProps) {
  return (
    <div className={`rounded-lg border p-3 ${relationshipColors[competitor.relationship]}`}>
      <div className="flex items-start justify-between">
        <div>
          <div className="font-medium text-gray-900">{competitor.name}</div>
          {competitor.company_name && competitor.company_name !== competitor.name && (
            <div className="text-xs text-gray-500">{competitor.company_name}</div>
          )}
        </div>
        <span
          className={`text-xs px-2 py-0.5 rounded ${relationshipBadgeColors[competitor.relationship]}`}
        >
          {competitor.relationship}
        </span>
      </div>
      {competitor.notes && <p className="mt-2 text-sm text-gray-600">{competitor.notes}</p>}
      {competitor.product_url && (
        <a
          href={competitor.product_url}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 inline-flex items-center text-xs text-primary-600 hover:text-primary-800"
        >
          View Product
          <svg className="ml-1 h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
            />
          </svg>
        </a>
      )}
    </div>
  );
}

export const CompetitorCard = memo(CompetitorCardComponent);
